import { useState, useEffect, useRef, useImperativeHandle ,forwardRef} from "react";
import "./filter.scss";

import Comp_GeneralFeatures from "../datacontrols/controlGeneral";
import Comp_Colonies from "../datacontrols/controlColony";
import Comp_TransactionType from "../datacontrols/controlTransactiontype";
import Comp_PropertyType from "../datacontrols/controlPropertytype";

import search from "../../assets/search.png";

const Filter = forwardRef (({ filterOptions = {}, onFilterApply },ref) =>{
  // Local state mirrors props for UI editing
  const [query, setQuery] = useState(filterOptions);

  // Refs for tag components
  const tagrefColony = useRef(null);
  const tagrefPropertyType = useRef(null);
  const tagrefTransactionType = useRef(null);
  const tagrefGeneral = useRef(null);

  const [selectedColonies, setSelectedColonies] = useState([]);
  const [selectedTransType,setselectedTranstype]=useState([])
  const [selectedPropertyType,setselectedPropertyType]=useState([])
  const [selectedGeneralTags,setselectedGeneralTags]=useState([])


    // useEffect(() => {
    // // Only update local state if it's actually different
    // if (JSON.stringify(query) !== JSON.stringify(filterOptions)) {
    //     setQuery(filterOptions);
    // }
    // }, [filterOptions]);


    // console.log("filterOptions",filterOptions);



    // useEffect(() => {
    // if (!tagrefColony.current || !tagrefPropertyType.current || !tagrefTransactionType.current || !tagrefGeneral.current) return;

    // // Colonies
    // const colonyObjs = filterOptions.colonies?.length
    //     ? tagrefColony.current.getObjectFromIds(filterOptions.colonies)
    //     : [];
    // setSelectedColonies(colonyObjs);

    // // Transaction Type
    // const transObjs = filterOptions.transtype
    //     ? tagrefTransactionType.current.getObjectFromIds([filterOptions.transtype])
    //     : [];
    // setselectedTranstype(transObjs);

    // // Property Type
    // const propObjs = filterOptions.propertytype?.length
    //     ? tagrefPropertyType.current.getObjectFromIds(filterOptions.propertytype)
    //     : [];
    // setselectedPropertyType(propObjs);

    //     // console.log("filteroptions tags ",filterOptions.tags)
    // // General Tags
    // const genObjs = filterOptions.tags?.length
    //     ? tagrefGeneral.current.getObjectFromIds(filterOptions.tags)
    //     : [];
    // // console.log("genObjs",genObjs);
    // setselectedGeneralTags(genObjs);

    // // Update query state
    // setQuery((prev) => ({
    //     ...prev,
    //     transtype: filterOptions.transtype ?? 0,
    //     propertytype: filterOptions.propertytype ?? [],
    //     colonies: filterOptions.colonies ?? [],
    //     tags: filterOptions.tags ?? [],
    //     maxprice: filterOptions.maxprice ?? 0,
    //     minprice: filterOptions.minprice ?? 0,
    //     bedroom: filterOptions.bedroom ?? 0,
    // }));

    // }, [filterOptions]);




useEffect(() => {
  if (!filterOptions) return;


  // const isDifferent =
  //   JSON.stringify(query) !== JSON.stringify(filterOptions);

  // if (!isDifferent) return;

  // setQuery(filterOptions);
  setQuery({ ...filterOptions });


  if (!tagrefColony.current) return;

  setSelectedColonies(
    filterOptions.colonies?.length
      ? tagrefColony.current.getObjectFromIds(filterOptions.colonies)
      : []
  );

  setselectedTranstype(
    filterOptions.transtype
      ? tagrefTransactionType.current.getObjectFromIds([filterOptions.transtype])
      : []
  );

  setselectedPropertyType(
    filterOptions.propertytype?.length
      ? tagrefPropertyType.current.getObjectFromIds(filterOptions.propertytype)
      : []
  );

  setselectedGeneralTags(
    filterOptions.tags?.length
      ? tagrefGeneral.current.getObjectFromIds(filterOptions.tags)
      : []
  );

}, [filterOptions]);



// Expose functions via ref
  useImperativeHandle(ref, () => ({
    showFilter: (newFilters) => {
      if (!newFilters) return;

      setQuery({ ...newFilters });

      // Update tag components
      if (tagrefColony.current) {
        setSelectedColonies(
          newFilters.colonies?.length
            ? tagrefColony.current.getObjectFromIds(newFilters.colonies)
            : []
        );
      }

      if (tagrefTransactionType.current) {
        // setselectedTranstype(

        setselectedTranstype(
          newFilters.transtype
            ? tagrefTransactionType.current.getObjectFromIds([newFilters.transtype])
            : []
        );
      }

      if (tagrefPropertyType.current) {
        setselectedPropertyType(
          newFilters.propertytype?.length
            ? tagrefPropertyType.current.getObjectFromIds(newFilters.propertytype)
            : []
        );
      }

      if (tagrefGeneral.current) {
        setselectedGeneralTags(
          newFilters.tags?.length
            ? tagrefGeneral.current.getObjectFromIds(newFilters.tags)
            : []
        );
      }
    },
  }));







// Tag change handlers
  const handleColonyChange = (newTags) => {
    setSelectedColonies(newTags);
    const filteredTags = newTags.filter(tag => tag != null && tag.status !== "delete");    
    // ✅ Prepare colonies array with only valid IDs
    const colonyIds = filteredTags
        .filter(tag => tag && tag.id != null) // remove any tag without an id
        .map(tag => tag.id);
    
      // ✅ Update query with valid colony IDs
      const updatedQuery = {
        ...query, // keep existing fields
        colonies: colonyIds,
      };
    setQuery(updatedQuery);
    // if (onFilterApply) onFilterApply(newQuery); // 
  };

  const handleTransTypeChange = (newTags) => {
    // const ids = tags.filter(tag => tag && tag.status !== "delete").map(tag => tag.id);
    // setQuery(prev => ({ ...prev, transtype: ids[0] || 0 }));
    setselectedTranstype(newTags);
    const filteredTags = newTags.filter(tag => tag != null && tag.status !== "delete");    
    // ✅ Prepare colonies array with only valid IDs
    const transIds = filteredTags
        .filter(tag => tag && tag.id != null) // remove any tag without an id
        .map(tag => tag.id);
    
      // ✅ Update query with valid colony IDs
      const updatedQuery = {
        ...query, // keep existing fields
        transtype: transIds[0],
      };
    setQuery(updatedQuery);
    



  };

  const handlePropertyTypeChange = (newTags) => {
    setselectedPropertyType(newTags);
    const filteredTags = newTags.filter(tag => tag != null && tag.status !== "delete");    
    // ✅ Prepare colonies array with only valid IDs
    const propIds = filteredTags
        .filter(tag => tag && tag.id != null) // remove any tag without an id
        .map(tag => tag.id);
    
      // ✅ Update query with valid colony IDs
      const updatedQuery = {
        ...query, // keep existing fields
        propertytype: propIds,
      };
    setQuery(updatedQuery);

};

  const handleGeneralTagChange = (newTags) => {
    // const ids = tags.filter(tag => tag && tag.status !== "delete").map(tag => tag.id);
    // setQuery(prev => ({ ...prev, tags: ids }));

    setselectedGeneralTags(newTags);
    const filteredTags = newTags.filter(tag => tag != null && tag.status !== "delete");    
    // ✅ Prepare colonies array with only valid IDs
    const genIds = filteredTags
        .filter(tag => tag && tag.id != null) // remove any tag without an id
        .map(tag => tag.id);
    
      // ✅ Update query with valid colony IDs
      const updatedQuery = {
        ...query, // keep existing fields
        tags: genIds,
      };
    setQuery(updatedQuery);

};

  // Basic input change handler
  const handleChange = (e) => {
    const { name, value } = e.target;
    setQuery(prev => ({ ...prev, [name]: value }));
  };

  // Apply button sends the current query to parent
  // const handleFilter = (e) => {
  //   e.preventDefault();
  //   // if (onFilterApply) onFilterApply(query);
    
  //   if (onFilterApply) onFilterApply({ ...query });

  // };


const handleFilter = (e) => {
  e.preventDefault();
  // console.log("selectedColonies",selectedColonies)

  // Build the final filter object from the current selected states
  const finalQuery = {
    // transtype: selectedTransType?.[0]?.id || 0,
    // propertytype: selectedPropertyType.map(t => t.id) || [],
    // colonies: selectedColonies.map(t => t.id) || [],
    // tags: selectedGeneralTags.map(t => t.id) || [],


    transtype: selectedTransType
        ?.filter(t => t.status !== "delete")[0]?.id || 0,

    propertytype: selectedPropertyType
        ?.filter(t => t.status !== "delete")
    .map(t => t.id) || [],

    colonies: selectedColonies
      ?.filter(colony => colony.status !== "delete")
      .map(colony => colony.id) || [],

    tags: selectedGeneralTags
        ?.filter(t => t.status !== "delete")
        .map(t => t.id) || [],

    bedroom: query.bedroom || 0,
    minprice: query.minprice || 0,
    maxprice: query.maxprice || 0,
  };

  // console.log("Filter Apply clicked. Final Query:", finalQuery);

  if (onFilterApply) onFilterApply(finalQuery);
};


// const handleFilter = (e) => {
//   e.preventDefault();

//   const finalQuery = {
//     ...query,
//     transtype: selectedTransType?.[0]?.id || 0,
//     propertytype: selectedPropertyType.map(t => t.id) || [],
//     colonies: selectedColonies.map(t => t.id) || [],
//     tags: selectedGeneralTags.map(t => t.id) || [],
//   };

//   if (onFilterApply) onFilterApply(finalQuery);
// };


  return (
    <div className="filter">
  
      <div className="row first">
        <div className="item">
          <Comp_Colonies
            ref={tagrefColony}
            defaultTags={selectedColonies}
            selectedTags={selectedColonies}
            setSelectedTags={(tags) =>
                handleColonyChange(tags)}
          />
        </div>
      </div>

      <div className="row second">
        <div className="item dropdown">
          <label>Type</label>
          <Comp_TransactionType
            ref={tagrefTransactionType}
            defaultTags={selectedTransType}
            selectedTags={selectedTransType}
            setSelectedTags={(tags) => handleTransTypeChange(tags)}
          />
        </div>
      </div>

      <div className="row third">
        <div className="item dropdown">
          <label>Property</label>
          <Comp_PropertyType
            ref={tagrefPropertyType}
            defaultTags={selectedPropertyType}
            selectedTags={selectedPropertyType}
            setSelectedTags={(tags) => handlePropertyTypeChange(tags)}
          />
        </div>
      </div>

      <div className="row fourth">

        <div className="item">
          <label>Bedroom</label>
          <input
            type="number"
            name="bedroom"
            value={query?.bedroom || ""}
            onChange={handleChange}
            placeholder="Beds"
          />
        </div>

        <div className="item">
          <label>Min Price</label>
          <input
            type="number"
            name="minprice"
            value={query?.minprice || ""}
            onChange={handleChange}
            placeholder="any"
          />
        </div>

        <div className="item">
          <label>Max Price</label>
          <input
            type="number"
            name="maxprice"
            value={query?.maxprice || ""}
            onChange={handleChange}
            placeholder="any"
          />
        </div>

      </div>

      <div className="row fifth">
        <div className="item">
          <label>Tags</label>
          <Comp_GeneralFeatures
            ref={tagrefGeneral}
            defaultTags={selectedGeneralTags}
            selectedTags={selectedGeneralTags}
            setSelectedTags={(tags) => handleGeneralTagChange(tags)}
          />
        </div>
      </div>
      <div className="row sixth">
        {/* <div className="item srchButton"> */}
          <button onClick={handleFilter}>
            <img src={search} alt="search" />
          </button>
        {/* </div> */}

      </div>
    </div>
  );
});

export default Filter;
